import Commissions from "../../components/commissions";

export default Commissions;
